(function($) {

    var $slick_nav = $('#nav-main');
    var $slick_nav_bnt = $('.nav-main-top');
    var $slick_nav_bnt_close = $('.nav-main__close');
    // $('#nav-main-bnt').slicknav('toggle');

    $slick_nav_bnt.click(function () {
        $('.nav-lang, .search-bar').removeClass('active');

        $slick_nav.slicknav('toggle');
        $slick_nav_bnt.toggleClass('active');
        return false;
    });
    $slick_nav_bnt_close.click(function () {
        $slick_nav_bnt.removeClass('active');
        $slick_nav_bnt.slicknav('close');
        return false;
    });

    // $slick_nav.slicknav();

    //*
    $slick_nav.slicknav({
        label: '',
        closedSymbol: "",
        openedSymbol: "",
        allowParentLinks: true,
        parentTag: "span",
        beforeOpen: function (t) {
        },
        beforeClose: function (t) {
            $slick_nav.removeClass('active');
        }
    });
    //*/
})(jQuery);
